import Scan from './Scan';

export type BaseResponse<T> = {
	errorMessage?: string;
	hasError: boolean;
	result: T;
};

/** Конфигурация модуля сканирования */
export type ScanConfigType = {
	/** URL для установки модуля*/
	scanModuleInstallUrl: string | null;
	/** Версия установленного модуля сканирования */
	scanModuleVersion: string;
	/** URL для работы с модулем сканирования */
	scanModuleWorkUrl: string | null;
};

export const ScanFormats = ['jpeg', 'tiff', 'pdf'];

export type ScanSettingType = {
	ADFMode?: string;
	Dpi: string;
	Format: string;
	Mode: string;
	Quality: string;
	SourceName?: string;
	UseADF?: boolean;
	docName?: string;
};

export type ScanVersionType = {
	version: number;
	versionAsse: string;
};

export const enum Rotate {
	Left = -90,
	Right = 90,
}

export type ScanFileType = {
	filename: string;
	ext: string;
	fullFileName: string;
	filename_utf8: string;
	hasError: boolean;
	result: Blob;
};

export { default as useScan } from './useScan';

export default Scan;
